export default __webpack_public_path__ + "static/media/section3.118cd4c3.jpg";